import moment from "moment";
import "moment/locale/ko";
/**
 * @summary 입력된 포멧(strFormat)으로 날짜의 형식을 바꿈.
 *
 * @param {Date} date
 * @param {string} strFormat
 */
//function formatDA(date, strFormat = "MMM D, YYYY") {
//function formatDA(date, strFormat = "YYYY-MM-DD") {
function formatDA(date, strFormat = "YY-MM-DD") {
  if (!date) {
    return;
  }
  const dateAsMoment = moment(date, "YYYYMMDD").locale("en");

  return dateAsMoment.format(strFormat);
}

/**
 * @summary 소수점 정확도를 변경
 *
 * @param {*} number            숫자
 * @param {string} precision    소수점 정확도
 */
function formatNumberPrecision(number, precision) {
  if (number !== null) {
    return parseFloat(number).toFixed(precision);
  }
}

/**
 * @summary
 *
 * @param {*} name
 */
function formatPN(name) {
  if (!name) {
    return;
  }

  // Convert the first ^ to a ', '. String.replace() only affects
  // the first appearance of the character.
  const commaBetweenFirstAndLast = name.replace("^", ", ");

  // Replace any remaining '^' characters with spaces
  const cleaned = commaBetweenFirstAndLast.replace(/\^/g, " ");

  // Trim any extraneous whitespace
  return cleaned.trim();
}

/**
 *
 * @param {*} time
 * @param {*} format
 */
//function formatTM(time, format = "a h:m:s") {
function formatTM(time, format = "a h:m:s", inputFormat = "hmmss.SSS") {
  if (!time) {
    return;
  }

  // DICOM Time is stored as HHmmss.SSS, where:
  //      HH 24 hour time:
  //      m mm    0..59   Minutes
  //      s ss    0..59   Seconds
  //      S SS SSS    0..999  Fractional seconds
  //
  // See MomentJS: http://momentjs.com/docs/#/parsing/string-format/
  //const dateTime = moment(time, "HHmmss.SSS").locale("ko");
  const dateTime = moment(time, inputFormat).locale("en");
  return dateTime.format(format);
}
function formatDATM(time, format) {
  const dateTime = moment(time, "YYYYMMDD.hmmss.SSS").locale("en");
  return dateTime.format(format);
}
export { formatDA, formatNumberPrecision, formatPN, formatTM, formatDATM };
